// Google reCAPTCHA v3 — невидимая капча.
// Site key задаётся через VITE_RECAPTCHA_SITE_KEY (в .env.prod). Если ключ не задан
// (DEV) — executeRecaptcha возвращает null, а backend при RECAPTCHA_ENABLED=false
// проверку пропускает. Скрипт грузится лениво, один раз, при первом вызове.
//
// fail-open: если скрипт Google не прогрузился (частая ситуация в РФ) —
// возвращаем null, регистрация не блокируется на фронте; backend тоже fail-open.

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';

let scriptPromise = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(false);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve) => {
    // уже загружен?
    if (window.grecaptcha && window.grecaptcha.execute) {
      resolve(true);
      return;
    }
    const s = document.createElement('script');
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false); // Google недоступен → fail-open
    document.head.appendChild(s);
  });
  return scriptPromise;
}

/**
 * Получить reCAPTCHA-токен для действия (action).
 * @param {string} action — 'register' | 'reset_password'
 * @returns {Promise<string|null>} токен или null (ключ не задан / Google недоступен)
 */
export async function executeRecaptcha(action) {
  if (!SITE_KEY) return null;
  try {
    const ok = await loadScript();
    if (!ok || !window.grecaptcha) return null;
    return await new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_KEY, { action })
          .then((token) => resolve(token))
          .catch(() => resolve(null));
      });
    });
  } catch {
    return null; // любой сбой — fail-open
  }
}

export const RECAPTCHA_ENABLED = Boolean(SITE_KEY);
